import slugify from "slugify";
import store from "@/store";

const monthNames = [
  "Jan",
  "Feb",
  "Mär",
  "Apr",
  "Mai",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Okt",
  "Nov",
  "Dez",
];

const weekday = new Array(7);
weekday[0] = "So";
weekday[1] = "Mo";
weekday[2] = "Di";
weekday[3] = "Mi";
weekday[4] = "Do";
weekday[5] = "Fr";
weekday[6] = "Sa";

const formateDatetime = (datetime) => {
  const date = new Date(datetime);
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = date.getFullYear();
  const hh = date.getHours();
  const ii = String(date.getMinutes()).padStart(2, "0");
  const s = String(date.getSeconds()).padStart(2, "0");
  return yyyy + "-" + mm + "-" + dd + "T" + hh + ":" + ii + ":" + s;
  // 2020-11-28T08:00:00
};

const formateDate = (dateInput, format) => {
  switch (format) {
    case "dd.mm.yyyy": {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      const today = new Date(dateInput);

      // console.log(today.toLocaleDateString("de-DE", options));
      return today.toLocaleDateString("de-DE", options);
    }

    default: {
      const date = new Date(dateInput);

      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
      const yyyy = date.getFullYear();
      return yyyy + "-" + mm + "-" + dd;
    }
  }
};

const formateDateShort = (date, lang = "de") => {
  if (date == null) {
    return;
  }

  const newdate = new Date(date);

  let locale = (typeof lang === 'string') ? lang.toLowerCase() : "de";
  if (locale === "us" || locale === "uk" || locale === "gb") {
    locale = "en";
  }

  // 2. Native Übersetzung statt hardgecodeter Arrays
  const DD = newdate.toLocaleDateString(locale, { weekday: "short", timeZone: "UTC" });

  const dd = String(newdate.getUTCDate()).padStart(2, "0");

  const MM = newdate.toLocaleDateString(locale, { month: "short", timeZone: "UTC" });

  const crentReservation = document.getElementById("crentReservation");
  if (crentReservation?.dataset?.dateformat) {
    switch (crentReservation.dataset.dateformat) {
      case "dd.mm.yy":
        return newdate.toLocaleDateString(locale, { timeZone: "UTC" });
      default:
        return DD.replace('.', '') + ", " + dd + ". " + MM;
    }
  }

  return DD.replace('.', '') + ", " + dd + ". " + MM;
};

const formatDayOfWeek = (date) => {
  const newdate = new Date(date);
  return newdate.getDay();
};

const addZero = (i) => {
  if (i < 10) {
    i = "0" + i;
  }
  return i;
};

const formatHour = (date) => {
  const hour = addZero(date.getHours());
  const minute = addZero(date.getMinutes());
  return hour + ":" + minute;
};
const formatTime = (date) => {
  const newdate = new Date(date);

  const hour = addZero(newdate.getUTCHours());
  const minute = addZero(newdate.getUTCMinutes());
  return hour + ":" + minute;
};

const formateTimeArray = (time) => {
  const newTime = new Date(time);
  const dateArray = [];
  dateArray.push(addZero(newTime.getHours()));
  dateArray.push(addZero(newTime.getMinutes()));
  return dateArray.join(":");
};

const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};
const getDistanceFromLatLonInKm = (lat, lng, posUser) => {
  // console.log(posUser);
  const lat1 = lat;
  const lng1 = lng;
  const lat2 = posUser.lat;
  const lng2 = posUser.lng;

  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLng = deg2rad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return Math.round((d + Number.EPSILON) * 100) / 100;
};

const slugMe = (string) => {
  return slugify(string, {
    replacement: "-", // replace spaces with replacement character, defaults to `-`
    remove: /[*+~.()'"!:,@/]/g, // remove characters that match regex, defaults to `undefined`
    lower: true, // convert to lower case, defaults to `false`
    strict: false, // strip special characters except replacement, defaults to `false`
    locale: "de", // language code of the locale to use
  });
};

const convertCurrency = (price) => {
  let locale = store.getters["general/GET_LANGUAGE"];
  const lang = {
    DEFAULT: "de-DE",
    DE: "de-DE",
    JP: "ja-JP",
    US: "en-US",
    FR: "fr-FR",
    CA: "fr-CA",
    CH: "fr-CH",
    GB: "en-GB",
  };

  const currencies = {
    DEFAULT: "EUR",
    DE: "EUR",
    JP: "EUR",
    US: "EUR",
    FR: "EUR",
    CA: "EUR",
    CH: "EUR",
    GB: "EUR",
  };
  if (lang[locale] == undefined) locale = "DE";
  const priceInt = parseFloat(price) || 0;

  const currencyConfig = store.getters["ORMgeneral/GET_CURRENCY"];
  const currencyData = Array.isArray(currencyConfig)
      ? currencyConfig[0]
      : currencyConfig;
  //if api call deliver no data, then the old behavior
  /* { "description": "Euro",  "iso_code": "EUR", "symbol": "€", "mantissa": 0, "separator_decimal": ",",
  "separator_thousand": ".", "conversion": 1,  "symbol_before_amount": false }
  */
  if (!currencyData || typeof currencyData !== "object") {
       return priceInt.toLocaleString(lang[locale], {
         style: "currency",
         currency: currencies[locale],
       });
  }
  //new formating based on api call delivered information
  const isoCode = currencyData.iso_code || currencies[locale] || "EUR";
  //console.log(currencyData);
  const symbol = currencyData.symbol || isoCode;
  const parsedMantissa = Number(currencyData.mantissa);
  // Keep legacy display behavior: always show at least 2 decimals (z.B.: 30,00 €).
  const mantissa = Number.isFinite(parsedMantissa)
      ? Math.max(2, parsedMantissa)
      : 2;
  const separatorDecimal = currencyData.separator_decimal || ",";
  const separatorThousand = currencyData.separator_thousand || ".";
  //const conversion = Number(currencyData.conversion) || 1; //in case for the future, if can be applied - Info delivered by API too
  const conversion = 1;

  const convertedPrice = priceInt * conversion;
  const fixedPrice = convertedPrice.toFixed(mantissa);
  const [integerPartRaw, decimalPart] = fixedPrice.split(".");
  //to handle a boolean value from the api call. This way "currencyData.symbol_before_amount || false"  does not work;
  const isSymbolBeforeAmount = (() => {
    const flag = currencyData.symbol_before_amount;
    if (flag !== undefined && flag !== null) {
      return flag === true || flag === 1;
    }
    return false;
  })();
  //console.log(isSymbolBeforeAmount);
  let integerPart = integerPartRaw;

  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separatorThousand);
  //Prevent the return carriage in text
  const nbsp = "\u00A0";
  if (mantissa > 0) {
    if (isSymbolBeforeAmount) {
      return `${symbol}${nbsp}${integerPart}${separatorDecimal}${decimalPart}`;
    }    
    return `${integerPart}${separatorDecimal}${decimalPart}${nbsp}${symbol}`;
  }
  if (isSymbolBeforeAmount) {
    return `${symbol}${nbsp}${integerPart}${nbsp}${decimalPart}`;
  }
  return `${integerPart}${nbsp}${symbol}${decimalPart}`;
};

const i18n = (id) => {
  return store.getters["general/GET_TRANSLATION"](id);
};

const concatDateTimeZone = (date, time) => {
  let startTimeDate = "";
  let endTimeDate = "";
  let st = "";
  const timeNow = formatHour(new Date());

  if (date.start) {
    if (time.start) {
      st = time.start + ":00";
    } else {
      st = timeNow + ":00";
    }
    startTimeDate = date.start + "T" + st;
  } else {
    startTimeDate = formateDatetime(Date.now());
  }
  if (date.end) {
    // console.log('time', time.end);
    if (time.end) {
      st = time.end + ":00";
    } else {
      st = timeNow + ":00";
    }
    endTimeDate = date.end + "T" + st;
  } else {
    endTimeDate = formateDatetime(Date.now());
  }
  return [startTimeDate, endTimeDate];
};

const formateDateDayLong = (date, lang = "de") => {
  const options = {
    weekday: "short",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const today = new Date(date);

  let locale = (typeof lang === 'string') ? lang.toLowerCase() : "de";
  if (locale === "us" || locale === "uk" || locale === "gb") {
    locale = "en";
  }

  return today.toLocaleDateString(locale, options);
};

const formateToGermanDate = (dateInput) => {
  if (!dateInput) return "";

  // Wenn es schon im deutschen Format ist, direkt zurückgeben
  if (dateInput.includes('.')) return dateInput;

  // Wenn es ein ISO-String mit Bindestrichen ist (yyyy-mm-dd)
  if (dateInput.includes('-')) {
    // Wir splitten den String am Bindestrich, um Zeitzonen-Verschiebungen durch "new Date()" zu umgehen
    const parts = dateInput.split('T')[0].split('-');
    if (parts.length === 3) {
      const [yyyy, mm, dd] = parts;
      return `${dd}.${mm}.${yyyy}`;
    }
  }

  // Fallback für alle anderen Fälle über das native Date-Objekt
  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return dateInput; // Falls kein valides Datum

  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
};

export {
  formateDate,
  formateDatetime,
  formatDayOfWeek,
  formateTimeArray,
  addZero,
  formateDateShort,
  formatHour,
  formatTime,
  getDistanceFromLatLonInKm,
  slugMe,
  convertCurrency,
  i18n,
  concatDateTimeZone,
  formateDateDayLong,
  formateToGermanDate,
};
